// extracted by mini-css-extract-plugin
export default {"pageInfo":"PageInfoV2_pageInfo__uaL4B","header":"PageInfoV2_header__lLrN7","line":"PageInfoV2_line__XbLYk","textBox":"PageInfoV2_textBox__VhdzK","image":"PageInfoV2_image__JvFxN"};